import React, { useEffect, useState } from 'react';

/**
 * Kompakter Auto-Slider für Bild-URLs (Crossfade + Punkte).
 * Bei nur einem Bild wird es statisch angezeigt.
 */
const ImageSlider: React.FC<{ images: string[]; alt?: string; className?: string }> = ({
  images,
  alt = '',
  className,
}) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (images.length < 2) return;
    const timer = setInterval(() => setIndex((i) => (i + 1) % images.length), 3500);
    return () => clearInterval(timer);
  }, [images.length]);

  if (images.length === 0) return null;

  return (
    <div className={`relative h-full w-full overflow-hidden ${className ?? ''}`}>
      {images.map((src, i) => (
        <img
          key={src + i}
          src={src}
          alt={alt}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover transition-opacity duration-700"
          style={{ opacity: i === index ? 1 : 0 }}
        />
      ))}
      {images.length > 1 && (
        <div className="absolute bottom-1.5 left-0 right-0 flex justify-center gap-1">
          {images.map((_, i) => (
            <span
              key={i}
              className="h-1.5 w-1.5 rounded-full transition-colors"
              style={{ backgroundColor: i === index ? '#3fced1' : 'rgba(255,255,255,0.4)' }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageSlider;
